import { ReactNode, useMemo } from "react";

import { TabInterface } from "@bridgesplit/ui";
import { COPY } from "app/constants";

export enum VaultDetailTab {
    Overview = "overview",
    Allocation = "allocation",
    Position = "position",
    Activity = "activity",
    Risk = "risk"
}

export type VaultTabVariant = "lend" | "earn";

const TAB_LABELS: Record<VaultDetailTab, string> = {
    [VaultDetailTab.Overview]: "Overview",
    [VaultDetailTab.Activity]: "Activity",
    [VaultDetailTab.Position]: "Position",
    [VaultDetailTab.Allocation]: "Allocation",
    [VaultDetailTab.Risk]: "Risk"
};

export function useVaultTabs({
    variant,
    vaultAddress,
    overview,
    activity,
    position,
    allocation,
    risk
}: {
    variant: VaultTabVariant;
    vaultAddress: string | undefined;
    overview?: ReactNode;
    activity?: ReactNode;
    position?: ReactNode;
    allocation?: ReactNode;
    // When provided, the Position tab is always shown but disabled (with this tooltip) if `position` is empty.
    risk?: ReactNode;
}): TabInterface[] {
    return useMemo(() => {
        const tabs: TabInterface[] = [];
        if (overview) {
            tabs.push({
                id: VaultDetailTab.Overview,
                label: TAB_LABELS[VaultDetailTab.Overview],
                component: overview
            });
        }
        if (position) {
            tabs.push({
                id: VaultDetailTab.Position,
                label: TAB_LABELS[VaultDetailTab.Position],
                component: position
            });
        } else {
            tabs.push({
                id: VaultDetailTab.Position,
                label: TAB_LABELS[VaultDetailTab.Position],
                component: null,
                disabled: true,
                tooltip: COPY.NO_ACTIVE_POSITION_IN_VAULT
            });
        }

        if (allocation) {
            tabs.push({
                id: VaultDetailTab.Allocation,
                label: TAB_LABELS[VaultDetailTab.Allocation],
                component: allocation
            });
        }
        if (activity) {
            tabs.push({
                id: VaultDetailTab.Activity,
                label: TAB_LABELS[VaultDetailTab.Activity],
                component: activity
            });
        }
        if (risk) {
            tabs.push({
                id: VaultDetailTab.Risk,
                label: TAB_LABELS[VaultDetailTab.Risk],
                component: risk
            });
        }
        return tabs;
    }, [overview, activity, position, allocation, risk]);
}
